import React from 'react';
export const useOptionsMap = options => {
  const optionsMap = React.useMemo(() => {
    var _options$reduce;
    return (_options$reduce = options === null || options === void 0 ? void 0 : options.reduce((map, itemOrGroup) => {
      const itemGroup = itemOrGroup.options ? itemOrGroup : undefined;
      const item = itemGroup ? undefined : itemOrGroup;
      if (itemGroup) {
        itemGroup.options.forEach(opt => map[opt.value] = opt);
      } else if (item) {
        map[item.value] = item;
      }
      return map;
    }, {})) !== null && _options$reduce !== void 0 ? _options$reduce : {};
  }, [options]);
  return optionsMap;
};